import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { Formik } from 'formik'
import TextArea from '../../../../widgets/components/Input/TextArea'
import { Dispatch, SetStateAction, useState } from 'react'
import { createOrUpdateBankDetails } from '../../core/_requests'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../../../auth'
import * as Yup from 'yup'

export default function AddNoteModal({
  isActive,
  setIsActive,
  shareholderBankDetails,
  fetchBankDetails,
}: {
  isActive: boolean
  setIsActive: Dispatch<SetStateAction<boolean>>
  shareholderBankDetails: any
  fetchBankDetails: (bankDetailId?: string) => void
}) {
  const { formatMessage } = useIntl()
  const { shareholderId } = useParams()
  const { companyId } = useAuth()
  const [isLoading, setIsLoading] = useState(false)

  const initialValues = {
    internalNotes: shareholderBankDetails?.internalNotes || null,
  }
  const userSchema = Yup.object().shape({
    internalNotes: Yup.string().nullable().required(formatMessage({ id: 'Internal notes is required' })),
  })

  const handleSubmit = async (values: any, { resetForm }: any) => {
    setIsLoading(true)
    try {
      if (shareholderBankDetails?.bankDetailId) {
        const {
          data: { success, errors, data },
        } = await createOrUpdateBankDetails(
          values,
          companyId!,
          shareholderId!,
          shareholderBankDetails?.bankDetailId
        )
        if (success) {
          toast.success(formatMessage({ id: 'Internal note updated successfully' }))
          setIsActive(false)
          await fetchBankDetails(data?.bankDetailId)
        } else {
          toast.error(errors[0])
        }
      } else {
        const {
          data: { success, errors, data },
        } = await createOrUpdateBankDetails(values, companyId!, shareholderId!)
        if (success) {
          toast.success(formatMessage({ id: 'Internal note added successfully' }))
          setIsActive(false)
          await fetchBankDetails(data?.bankDetailId)
        } else {
          toast.error(errors[0])
        }
      }

    } catch (error) {
      console.log(error)
    } finally {
      setIsActive(false)
      setIsLoading(false)
      resetForm()
    }
  }
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={userSchema}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnMount
        validateOnChange
      >
        {(formik) => (
          <Form>
            <Modal
              show={isActive}
              onHide={() => {
                setIsActive(false)
              }}
              size='lg'
              fullscreen
            >
              <Modal.Header closeButton>
                <h2>{formatMessage({ id: 'Internal Notes' })}</h2>
              </Modal.Header>
              <Modal.Body className='container'>
                <div className='w-100'>
                  <div className='row'>
                    <div className='col-md-12 col-12'>
                      <TextArea
                        label={formatMessage({ id: 'Notes' })}
                        fieldName='internalNotes'
                        formik={formik}
                        placeholder={formatMessage({ id: 'Enter Notes' })}
                        toolTipText={formatMessage({
                          id: 'Add any internal note pertaining to the added bank account and nominee.',
                        })}
                        isStarRequired={true}
                        isTooltipForModal={true}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer className='p-md-0 px-0 d-flex gap-2 gap-md-1 container'>
                <div className='d-flex gap-3  my-md-4 mx-6  mx-md-0 my-0 mb-2 justify-content-md-end justify-content-center w-md-auto w-100 order-2 order-md-1'>
                  <button
                    className='btn bg-light custom-button-property text-muted font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                    style={{ padding: '15px 40px' }}
                    onClick={() => {
                      setIsActive(false)
                      formik.resetForm()
                    }}
                  >
                    <span className='indicator-label font-size-13 p-0'>
                      {formatMessage({ id: 'Cancel' })}
                    </span>
                  </button>
                </div>
                <div className='d-flex gap-3  my-md-4  mx-6  mx-md-0 my-0 justify-content-md-end justify-content-center w-md-auto w-100 order-1 order-md-2'>
                  <button
                    className='btn bg-primary custom-button-property text-white font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                    style={{ padding: '15px 40px' }}
                    disabled={!formik.isValid || isLoading}
                    onClick={() => {
                      formik.handleSubmit()
                    }}
                  >
                    {isLoading ? (
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({ id: 'Please wait...' })}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    ) : (
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({ id: 'Save' })}
                      </span>
                    )}
                  </button>
                </div>
              </Modal.Footer>
            </Modal>
          </Form>
        )}
      </Formik>
    </>
  )
}
